import { Box, Button, TextField } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import BuzzModal from '../../../../components/BuzzModal/BuzzModal';
import { patchAppListAsync } from './appListStoreSlice';
import { toast } from 'react-toastify';

const SHAmodal = ({ _id, open = false, onClose = '' }) => {
  const [sha1, setSha1] = React.useState(null);
  const [sha256, setSha256] = React.useState(null);

  const dispatch = useDispatch();
  // const { patchapp } = useSelector((state) => {
  //   const { appListReducer } = state;

  //   return { patchapp: appListReducer.patchapp };
  // });

  const addUser = async () => {
    try {
      let payload = {
        _id,
        sha1: sha1,
        sha256: sha256,
      };
      dispatch(patchAppListAsync(payload))
        .unwrap()
        .then((res) => {
          toast.success(`SHA updated successfully.`);
        });
    } catch (error) {
      toast.error('SHA updated failed, please try again in some time!');
    }
  };

  return (
    <BuzzModal
      width={'30vw'}
      open={open}
      title={`Update SHA`}
      onClose={onClose}>
      <Box
        fontFamily={'Rubik'}
        display="flex"
        flexDirection={'column'}
        minHeight={'25vh'}
        justifyContent="space-between">
        <TextField
          label="Enter SHA-1"
          variant="outlined"
          size="small"
          value={sha1}
          onChange={(e) => setSha1(e.target.value)}
          fullwidth
        />
        <TextField
          label="Enter SHA-256"
          variant="outlined"
          size="small"
          value={sha256}
          onChange={(e) => setSha256(e.target.value)}
          fullwidth
        />
        <Button variant="contained" color="primary" onClick={addUser}>
          Save
        </Button>
      </Box>
    </BuzzModal>
  );
};

export default SHAmodal;
